import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box
} from '@mui/material';

export default function CreateProductDialog({ open, onClose, categories, onSubmit, initialData = null }) {
  const [newProduct, setNewProduct] = useState(initialData || {
    name: "",
    description: "",
    category_id: "",
    price: "",
    details: "",
    images: [],
  });
  const [imageInputs, setImageInputs] = useState(1);

  useEffect(() => {
    if (initialData) {
      setNewProduct(initialData);
    }
  }, [initialData]);

  const handleFileChange = (event, index) => {
    const files = Array.from(event.target.files);
    const updatedImages = [...newProduct.images];
    
    files.forEach((file, i) => {
      const newIndex = index + i;
      if (newIndex < 4) {
        updatedImages[newIndex] = {
          file,
          isPrimary: newIndex === 0
        };
      }
    });
  
    setNewProduct({ ...newProduct, images: updatedImages });
    setImageInputs(Math.min(updatedImages.length + 1, 4));
  };

  const handleSetPrimary = (index) => {
    const updatedImages = newProduct.images.map((img, i) => ({
      ...img,
      isPrimary: i === index
    }));
    setNewProduct({ ...newProduct, images: updatedImages });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Afegir un nou producte</DialogTitle>
      <DialogContent>
        <TextField 
          label="Nom" 
          fullWidth 
          sx={{ mt: 1 }}
          onChange={(e) => setNewProduct({ ...newProduct, name: e.target.value })} 
        />
        <TextField
          label="Descripció"
          fullWidth
          sx={{ mt: 2 }}
          onChange={(e) => setNewProduct({ ...newProduct, description: e.target.value })}
        />
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Categoria</InputLabel>
          <Select
            value={newProduct.category_id}
            onChange={(e) => setNewProduct({ ...newProduct, category_id: e.target.value })}
          >
            {categories.map((category) => (
              <MenuItem key={category.id} value={category.id}>{category.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Preu (€)"
          type="number"
          fullWidth
          sx={{ mt: 2 }}
          onChange={(e) => setNewProduct({ ...newProduct, price: e.target.value })}
        />

        {[...Array(imageInputs)].map((_, index) => (
          <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
            <input
              type="file"
              onChange={(e) => handleFileChange(e, index)}
              accept="image/*"
            />
            {newProduct.images[index] && (
              <>
                <img 
                  src={newProduct.images[index].preview} 
                  alt="preview"
                  style={{ height: 60, borderRadius: 4 }}
                />
                <Button
                  variant={newProduct.images[index]?.isPrimary ? "contained" : "outlined"}
                  size="small"
                  onClick={() => handleSetPrimary(index)}
                >
                  Principal
                </Button>
              </>
            )}
          </Box>
        ))}
        
        {imageInputs < 4 && (
          <Button onClick={() => setImageInputs(prev => prev + 1)} sx={{ mt: 1 }}>
            Adicionar outra imagem
          </Button>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel·lar</Button>
        <Button onClick={() => onSubmit(newProduct)}>
          {initialData ? "Guardar" : "Afegir"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}